import React from "react";
import middleware from "./middleware/middleware";
import AllPageSitePublisher from "../component/sections/page/AllPageSitePublisher";
import AddPageSitePublisher from "../component/sections/page/AddPageSitePublisher";
import EditPageSitePublisher from "../component/sections/page/EditPageSitePublisher";
import ViewInfoPageSitePublisher from "../component/sections/page/ViewInfoPageSitePublisher";

const sitesRoutes = [
  {
    path: "/page/all/publisher/:publisherID",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <AllPageSitePublisher />,
        "AllPageSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/page/add/publisher/:publisherID",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <AddPageSitePublisher />,
        "AddPageSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/page/edit/:pageID",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <EditPageSitePublisher />,
        "EditPageSitePublisher"
      );
    },
    exact: true,
  },
  {
    path: "/page/view/:pageID",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <ViewInfoPageSitePublisher />,
        "ViewInfoPageSitePublisher"
      );
    },
    exact: true,
  },
];

export default sitesRoutes;
